// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iTBu","footer":"styles_footer__20fZA"};